<!--退车变更记录-->
<template>
  <div class="details_content_repeat">
    <QS-h4-title title="车辆信息" />
    <QS-common-table
      :data="tableData"
      :columns="headColumn"
      :pagination="false"
    ></QS-common-table>
  </div>
</template>

<script>
// import { getPurchaseCarList } from '@/api/purchaseAndSaleAPI'
export default {
  name: 'TcbgTable',
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headColumn: [
        {
          name: 'index',
          columnProps: {
            label: '序号',
            prop: 'index',
          },
        },
        {
          name: 'carId',
          columnProps: {
            label: '车辆ID',
            prop: 'carId',
          },
        },
        {
          name: 'brandName',
          columnProps: {
            label: '品牌',
            prop: 'brandName',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            label: '车系',
            prop: 'seriesName',
          },
        },
        {
          name: 'carModel',
          columnProps: {
            label: '车型',
            prop: 'carModel',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'vin',
          columnProps: {
            prop: 'vin',
            label: 'VIN码',
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            label: '添加时间',
            prop: 'gmtCreate',
          },
        },
        {
          name: 'deptName',
          columnProps: {
            label: '所属部门',
            prop: 'deptName',
          },
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '车辆订单状态',
          },
          getText: ({ row }) => {
            if (row.state === 2) {
              return '进行中'
            } else if (row.state === 4) {
              return '已关闭'
            } else {
              return '--'
            }
          },
        },
      ],
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.txt-right {
  text-align: right;
}
</style>
